export const PlayIcon = (props) => (
  <svg fill="none" height={16} viewBox="0 0 24 24" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} />
    <path d="M10.4 8.6 15.2 12l-4.8 3.4V8.6Z" fill="currentColor" stroke="currentColor" strokeLinejoin="round" strokeWidth={1.1} />
  </svg>
);
